<template>
  <div style="padding: 5px">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3 dash-card">
          <v-toolbar
            class="q-orange-bk q-text-whitesmoke elevation-1"
            style="height: 50px"
          >
            <v-toolbar-title style="padding-bottom: 15px">
              <h3>{{ getString("Lista negozi") }}</h3>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row>
              <v-flex>
                <div
                  style="
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    border: solid 2px #999;
                    margin-bottom: 10px;
                  "
                  class="q-disabled-bk"
                >
                  <span style="margin-left: 25px">{{
                    getString("Disattivato")
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-btn class="q-orange-bk q-text-whitesmoke" @click="getShops">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-flex xs12 lg12>
                <v-text-field
                  type="text"
                  v-model="search"
                  :label="getString('Filtra')"
                  solo
                  color="red lighten-3"
                />
              </v-flex>
            </v-layout>
            <h3>
              {{ getString("Totale negozi: ") }}
              <b>{{ shops.length }}</b>
              {{ getString(" ( Negozi disabilitati: ") }}{{ disabledShops }}
              {{ getString(" - Negozi demo: ") }}{{ demoShops }}
              {{ getString(" - Negozi attivi: ") }}{{ activeShops }}

              {{ getString(" ) Platinum: ") }}{{ platinumShops }}
              {{ getString(" - Silver: ") }}{{ silverShops }}
            </h3>
            <v-data-table
              :headers="Headers"
              :items="shops"
              item-key="idBarberShop"
              :search="search"
              :rows-per-page-items="[
                { text: getString('Tutto'), value: -1 },
                10,
                25,
                50,
                100,
              ]"
              :rows-per-page-text="getString('Negozi per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              :loading="loading"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr
                  style="max-height: 100px; overflow: hidden; cursor: pointer"
                  :class="{
                    'q-disabled-bk': !props.item.isActive,
                    'q-text-whitesmoke': !props.item.isActive,
                  }"
                  v-if="
                    showDisabled !== undefined
                      ? true
                      : props.item.isActive ||
                        moment().diff(moment(props.item.expired), 'days') < 30
                  "
                >
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.idBarberShop }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="callSamFisher(props.item)">
                      <v-icon
                        :class="{ 'q-text-whitesmoke': props.item.expired > 0 }"
                        >fingerprint</v-icon
                      >
                    </v-btn>
                  </td>
                  <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.name }}
                  </td>
                  <td
                    class="text-xs-left"
                  >
                    {{ props.item.fullName }}
                  </td>
                  <!-- <td
                    @click="props.expanded = !props.expanded"
                    class="text-xs-left"
                  >
                    {{ props.item.address }}
                  </td> -->
                  <td class="text-xs-left">{{ props.item.city }}</td>
                  <!-- <td class="text-xs-left">{{ props.item.cap }}</td> -->
                  <!-- <td class="text-xs-left">{{ props.item.prov }}</td> -->
                  <td class="text-xs-left">
                    {{ props.item.expired.split("T")[0] }}
                  </td>
                  <td class="text-xs-left">
                    {{ moment(props.item.expired).diff(moment(), "days") }}
                  </td>
                  <td class="text-xs-left">
                    <h3>
                      {{
                        props.item.isBuilding === true
                          ? getString("Costruzione")
                          : "No"
                      }}
                    </h3>
                  </td>
                  <td class="text-xs-left">
                    <h3>
                      {{
                        props.item.isDemo === true ? getString("Demo") : "No"
                      }}
                    </h3>
                  </td>
                  <td class="text-xs-center">
                    <h3>{{ getCustom(props.item.dlc) }}</h3>
                  </td>
                  <td class="text-xs-center">
                    <h3>{{ props.item.maxEmployees }}</h3>
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="showPayment(props.item)">
                      <v-icon
                        :class="{ 'q-text-whitesmoke': !props.item.isActive }"
                        >attach_money</v-icon
                      >
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="getHistory(props.item)">
                      <v-icon
                        :class="{ 'q-text-whitesmoke': !props.item.isActive }"
                        >history</v-icon
                      >
                    </v-btn>
                  </td>
                  <td class="text-xs-center" @click="getNote(props.item)">
                    <v-btn flat>
                      <v-icon
                        :style="{ color: props.item.note !== '' && props.item.note !== null ? 'red' : 'defaultColor' }"
                        :class="{ 'q-text-whitesmoke': !props.item.isActive }"
                        >notes</v-icon
                      >
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="enableShop(props.item)">
                      <v-icon
                        :class="{ 'q-text-whitesmoke': !props.item.isActive }"
                        >remove_circle</v-icon
                      >
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card flat>
                  <v-card-title>
                    <h2 class="q-orange">{{ props.item.name }}</h2>
                  </v-card-title>
                  <v-card-text>
                    <label>Tel</label>
                    <p>{{ props.item.phone }} {{ props.item.phone2 }}</p>
                    <label>Desc</label>
                    <p>{{ props.item.description }}</p>
                    <label>Facebook Link</label>
                    <p>{{ props.item.facebookLink }}</p>
                    <label>Instagram Link</label>
                    <p>{{ props.item.instagramLink }}</p>
                    <label>Web Link</label>
                    <p>{{ props.item.webSiteLink }}</p>
                    <label>Building state</label>
                    <p>
                      {{
                        props.item.isBuilding === true
                          ? getString("Costruzione")
                          : "No"
                      }}
                    </p>
                  </v-card-text>
                </v-card>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="q-orange-bk q-text-whitesmoke"
              @click="newDialog = true"
              >{{ getString("Aggiungi nuovo negozio") }}</v-btn
            >
            <v-btn-toggle
              class="q-orange-bk"
              v-model="showDisabled"
              style="margin-left: 10px"
            >
              <v-btn flat class="q-text-whitesmoke"
                >{{
                  showDisabled !== undefined
                    ? getString("Nascondi ")
                    : getString("Mostra ")
                }}{{ getString("Disattivati") }}</v-btn
              >
            </v-btn-toggle>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="historyDialog" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            getString("Cronologia") + " " + selectedShop.name
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="HeadersHistory"
            :items="currHistory"
            :rows-per-page-items="[
              10,
              25,
              { text: getString('Tutto'), value: -1 },
            ]"
            :rows-per-page-text="getString('Prenotazioni per pagina')"
            :no-data-text="getString('Dati non disponibili')"
            :loading="hLoading"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-left">{{ props.item.idPayment }}</td>
                <td class="text-xs-left">{{ props.item.price }} €</td>
                <td class="text-xs-left">
                  {{ props.item.date.split("T")[0] }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.dateAdd.split("T")[0] }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.insider == 1 ? getString("Sì") : "No" }}
                </td>
                <td class="text-xs-left">{{ props.item.note }}</td>
                <td class="text-xs-left">
                  {{
                    props.item.pathInvoice === ""
                      ? "No"
                      : getString("Fattura già presente: ") +
                        props.item.pathInvoice
                  }}
                </td>
                <td class="text-xs-left">
                  <v-btn flat @click="upFattura(props.item)">
                    <v-icon>cloud_upload</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-progress-linear
            ref="fileUploadProgress"
            :value="fileUploadProgress"
            v-show="currHistoryProgress"
          ></v-progress-linear>
          <input
            type="file"
            accept="application/pdf"
            v-show="false"
            ref="fileFattura"
            @change="selectFile"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="historyDialog = false">{{
            getString("Chiudi")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="noteDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ getString("Nota per ") }}{{ selectedShop.name }}</span
          >
        </v-card-title>
        <v-card-text>
          <label>{{ getString("Note relative al negozio") }}</label>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm12 lg12 md12>
                <v-textarea
                  solo
                  v-bind:label="getString('Nota')"
                  v-model="currNote"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="noteDialog = false">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click.native="setNote">{{
            getString("Aggiorna")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="renewDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ getString("Rinnovo pagamento per ")
            }}{{ selectedShop.name }}</span
          >
        </v-card-title>
        <v-card-text>
          <label>{{ getString("Costo di rinnovo (0 se tester)") }}</label>
          <v-text-field
            type="number"
            min="0"
            v-model="dialogCost"
            :label="getString('Costo')"
          />
          <label>{{ getString("Data rinnovo") }}</label>
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="dialogDateMenu"
            :nudge-right="40"
            :return-value.sync="dialogDate"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dialogDate"
              :label="getString('Seleziona la data')"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              :locale="locale"
              v-model="dialogDate"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.menu.save(dialogDate)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu>
          <v-layout>
            <v-btn @click.native="() => setDate(1)">1</v-btn>
            <v-btn @click.native="() => setDate(3)">3</v-btn>
            <v-btn @click.native="() => setDate(6)">6</v-btn>
            <v-btn @click.native="() => setDate(12)">12</v-btn>
          </v-layout>
          <label>{{ getString("Nota relativa al rinnovo") }}</label>
          <v-textarea
            solo
            v-bind:label="getString('Nota')"
            v-model="dialogNote"
          ></v-textarea>
          <label>{{ getString("Insider (tester)") }}</label>
          <v-checkbox
            :label="`Insider? ${dialogCheck ? getString('Sì') : 'No'}`"
            v-model="dialogCheck"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="q-text-whitesmoke q-orange-bk"
            @click.native="setFree"
            >{{ getString("Rendi Free") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="q-text-whitesmoke q-orange-bk"
            @click.native="setSilver"
            >{{ getString("Rendi Silver") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="q-text-whitesmoke q-orange-bk"
            @click.native="setPlatinum"
            >{{ getString("Rendi Platinum") }}</v-btn
          >
        </v-card-actions>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="resetDialog">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click.native="setPayment">{{
            getString("Aggiungi pagamento")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newDialog" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            getString("Aggiungi un nuovo negozio")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg6 style="padding-right: 10px">
              <h2>{{ getString("Dati utente") }}</h2>
              <label>{{ getString("Nome negoziante") }}</label>
              <v-text-field
                v-model="nameNewDialog"
                solo
                :label="getString('Nome')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Cognome negoziante") }}</label>
              <v-text-field
                v-model="surnameNewDialog"
                solo
                :label="getString('Cognome')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Email") }}</label>
              <v-text-field
                v-model="emailNewDialog"
                solo
                :label="getString('Email')"
                :rules="emailRule"
                required
              ></v-text-field>
              <label>{{ getString("Telefono") }}</label>
              <v-text-field
                v-model="phoneNewDialog"
                solo
                :label="getString('Telefono')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <v-checkbox
                :label="`Demo? ${dialogCheck1 ? getString('Sì') : 'No'}`"
                v-model="dialogCheck1"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm12 md12 lg6>
              <h2>{{ getString("Dati negozio") }}</h2>
              <label>{{ getString("Nome negozio") }}</label>
              <v-text-field
                v-model="nameShopNewDialog"
                solo
                :label="getString('Nome attività')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Indirizzo") }}</label>
              <v-text-field
                v-model="addressNewDialog"
                solo
                :label="getString('Indirizzo')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Città") }}</label>
              <v-text-field
                v-model="cityNewDialog"
                solo
                :label="getString('Città')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Prov.") }}</label>
              <v-text-field
                v-model="provNewDialog"
                solo
                :label="getString('Provincia')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("CAP") }}</label>
              <v-text-field
                v-model="capNewDialog"
                solo
                :label="getString('Cap')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{
                getString("Coordinate geografiche (separate da ;)")
              }}</label>
              <v-text-field
                v-model="geoNewDialog"
                solo
                :label="getString('Es. 40,83;14,25')"
                :rules="notEmpty"
                required
              ></v-text-field>
              <label>{{ getString("Nota") }}</label>
              <v-textarea
                solo
                v-bind:label="getString('Nota')"
                v-model="noteNewDialog"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-progress-linear
          indeterminate
          active
          v-if="isLoadingNew"
          color="red lighten-2"
        ></v-progress-linear>
        <v-card-actions>
          <v-btn class="q-orange" flat @click.native="resetNewDialog">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="q-orange"
            :disabled="isLoadingNew"
            flat
            @click.native="newShop"
            >{{ getString("Aggiungi negozio") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="selectedFileBar" :timeout="0" ref="selectedFileBar">
      {{ selectedFile }}
      <v-btn flat @click="resetFile">{{
        getString("Annulla selezione")
      }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import ajax from "../../../ajax";
import Utils from "../../../utils";
import moment from "moment";
var ut = new Utils();
export default {
  name: "AdminShops",
  mounted: function () {
    this.init();
  },
  computed: {
    moment: function () {
      return moment;
    },
    disabledShops: function () {
      let i = 0;
      this.shops.forEach((element) => {
        if (!element.isActive) i++;
      });
      return i;
    },
    activeShops: function () {
      return this.shops.filter((x) => x.isActive && !x.isDemo).length;
    },
    platinumShops: function () {
      return this.shops
        .filter((x) => x.isActive && !x.isDemo)
        .reduce((acc, x) => {
          if (x.dlc.includes("V14")) {
            return acc + 1;
          }
          return acc;
        }, 0);
    },
    silverShops: function () {
      return this.shops
        .filter((x) => x.isActive && !x.isDemo)
        .reduce((acc, x) => {
          if (x.dlc.includes("V11")) {
            return acc + 1;
          }
          return acc;
        }, 0);
    },
    demoShops: function () {
      return this.shops.filter((x) => x.isActive && x.isDemo).length;
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) =>
          ut.ValidateNumber(v) ||
          this.getString("Numero non valido, torniamo a scuola per cortesia?"),
      ];
    },
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    Headers: function () {
      let result = [];
      let self = this;
      if (this.shops.length > 0) {
        let temp = [
          self.getString("Id:idBarberShop"),
          self.getString("4Echelon"),
          self.getString("Nome:name"),
          self.getString("Owner:fullName"),
          // self.getString("Indirizzo:address"),
          self.getString("Città:city"),
          // self.getString("Cap:cap"),
          // self.getString("Prov.:prov"),
          self.getString("Scadenza:expired"),
          self.getString("Giorni"),
          self.getString("Building:isBuilding"),
          self.getString("Demo:isDemo"),
          self.getString("Contratto:dlc"),
          self.getString("MaxColl:maxEmployees"),
          self.getString("Rinnova"),
          self.getString("Storico"),
          self.getString("Nota"),
          self.getString("Disabilita"),
        ];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: element.split(":").length > 1 ? "left" : "center",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
    HeadersHistory: function () {
      let result = [];
      let self = this;
      if (this.currHistory.length > 0) {
        let temp = [
          self.getString("Id"),
          self.getString("Pagato"),
          self.getString("Rinnovo precedente"),
          self.getString("Data nuova"),
          self.getString("Tester"),
          self.getString("Nota"),
          self.getString("Fattura presente"),
          self.getString("Overwrite fattura"),
        ];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: "left",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
  },
  data: () => {
    return {
      isLoadingNew: false,
      h: null,
      active: null,
      showDisabled: undefined,
      shops: [],
      search: null,
      fileUploadProgress: 0,
      loading: false,
      hLoading: false,
      historyDialog: false,
      selectedShop: {},
      currHistory: [],
      currHistoryProgress: false,
      selectedFileBar: false,
      selectedFile: "",
      noteDialog: false,
      currNote: "",
      renewDialog: false,
      dialogCost: 0,
      dialogDateMenu: false,
      dialogNote: "",
      dialogCheck: false,
      dialogCheck1: false,
      dialogDate: null,
      dialogOldDate: null,
      newDialog: false,
      nameNewDialog: "",
      surnameNewDialog: "",
      emailNewDialog: "",
      phoneNewDialog: "",
      nameShopNewDialog: "",
      addressNewDialog: "",
      cityNewDialog: "",
      provNewDialog: "",
      capNewDialog: "",
      geoNewDialog: "",
      noteNewDialog: "",
    };
  },
  methods: {
    callSamFisher: function (item) {
      let self = this;
      ajax.axios
        .get(
          ajax.baseUrl() +
            "/admin/man/samfisher/" +
            item.owner +
            "/name/" +
            encodeURIComponent(item.name),
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$store.commit("setfakeUser", response.data.data.token);
          self.$emit("siteAlertSuccess", response.data.data.message);
          self.$emit("refreshShops");
          self.$router.push("/admin/dashboard");
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    resetNewDialog: function () {
      this.nameNewDialog = "";
      this.surnameNewDialog = "";
      this.emailNewDialog = "";
      this.phoneNewDialog = "";
      this.nameShopNewDialog = "";
      this.addressNewDialog = "";
      this.cityNewDialog = "";
      this.provNewDialog = "";
      this.capNewDialog = "";
      this.geoNewDialog = "";
      this.noteNewDialog = "";
      this.newDialog = false;
    },
    newShop: function () {
      let self = this;
      self.isLoadingNew = true;
      var geo = (self.geoNewDialog || "").split(";");
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/man/shop",
          {
            name: self.nameNewDialog,
            surname: self.surnameNewDialog,
            email: self.emailNewDialog,
            phone: self.phoneNewDialog,
            shopName: self.nameShopNewDialog,
            address: self.addressNewDialog,
            city: self.cityNewDialog,
            prov: self.provNewDialog,
            cap: self.capNewDialog,
            lat: geo[0],
            lon: geo[1],
            note: self.noteNewDialog,
            demo: self.dialogCheck1,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.isLoadingNew = false;
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.resetNewDialog();
        })
        .catch(function (error) {
          self.isLoadingNew = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    resetDialog: function (shop) {
      this.renewDialog = false;
      this.dialogCost = 0;
      this.dialogDateMenu = false;
      this.dialogNote = "";
      this.dialogDate = moment(shop.expired).format("YYYY-MM-DD");
      this.dialogOldDate = moment(shop.expired).format("YYYY-MM-DD");
    },
    getCustom: function (dlc) {
      let temp = (dlc + "").split(",");
      for (let index = 0; index < temp.length; index++) {
        const element = temp[index];
        if (element === "V10") {
          return "Free";
        }
        if (element === "V11") {
          return "Silver";
        }
        if (element === "V14") {
          return "Platinum";
        }
      }
      return "undefined";
    },
    init: function () {
      this.getShops();
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    enableShop: function (shop) {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/man/enableshop/" + shop.idBarberShop,
          {
            enable: !shop.isActive,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.loading = false;
          shop.isActive = !shop.isActive;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getNote: function (shop) {
      let self = this;
      this.selectedShop = shop;
      this.noteDialog = true;
      ajax.axios
        .get(
          ajax.baseUrl() + "/admin/man/shop/" + shop.idBarberShop + "/note",
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.currNote = response.data.data;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    setFree: function () {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/man/shop/owner/" +
            self.selectedShop.owner +
            "/free",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    setDate: function(months) {
      this.dialogDate = moment(this.dialogDate).add(months, "M").format("YYYY-MM-DD")
    },
    setNote: function() {
      let self = this
      this.noteDialog = true
      ajax.axios
        .put(
          ajax.baseUrl() +
            '/admin/man/shop/' +
            self.selectedShop.idBarberShop +
            '/note',
          {
            note: self.currNote
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true
          }
        )
        .then(function(response) {
          ajax.validateToken(response.headers)
          self.$emit('siteAlertSuccess', response.data.data)
          self.noteDialog = false;
        })
        .catch(function(error) {
          var auth = ajax.checkAuth(error)
          self.$emit(
            'siteAlert',
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          )
        })
    },
    setSilver: function () {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/man/shop/owner/" +
            self.selectedShop.owner +
            "/silver",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    setPlatinum: function () {
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/man/shop/owner/" +
            self.selectedShop.owner +
            "/platinum",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    showPayment: function (shop) {
      this.selectedShop = shop;
      this.resetDialog(shop);
      this.renewDialog = true;
    },
    setPayment: function () {
      let self = this;
      ajax.axios
        .post(
          ajax.baseUrl() +
            "/admin/man/shop/" +
            self.selectedShop.idBarberShop +
            "/renew",
          {
            cost: self.dialogCost,
            date: self.dialogDate,
            oldDate: self.dialogOldDate,
            note: self.dialogNote,
            test: self.dialogCheck ? 1 : 0,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data);
          self.resetDialog();
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getShops: function () {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/man/getshops", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.shops = response.data.data;
          self.loading = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getHistory: function (shop) {
      let self = this;
      this.hLoading = true;
      this.historyDialog = true;
      this.selectedShop = shop;
      ajax.axios
        .get(
          ajax.baseUrl() + "/admin/man/shop/" + shop.idBarberShop + "/history",
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.currHistory = response.data.data;
          self.hLoading = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.hLoading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    resetFile: function () {
      this.currHistoryProgress = false;
      this.selectedFile = null;
      this.selectedFileBar = false;
      this.fileUploadProgress = 0;
    },
    selectFile: function () {
      this.selectedFile = this.$refs.fileFattura.files[0];
      this.selectedFileBar = true;
    },
    upFattura: function (item) {
      //let file = this.$refs.fileFattura.files.length > 0;
      if (this.selectedFile) {
        this.currHistoryProgress = true;
        this.uploadFattura(item, this.selectedFile);
      } else {
        this.$refs.fileFattura.click();
      }
    },
    uploadFattura: function (item, file) {
      let data = new FormData();
      let self = this;
      data.append("files", file);
      if (/\.pdf$/i.test(file.name)) {
        ajax.axios
          .post(
            ajax.baseUrl() + "/admin/man/payment/" + item.idPayment + "/upload",
            data,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + self.$store.getters.token,
              },
              onUploadProgress: function (progressEvent) {
                let p = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
                self.fileUploadProgress = p;
              }.bind(this),
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            self.resetFile();
            self.getHistory(self.selectedShop);
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.resetFile();
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      } else {
        this.emit("siteAlert", this.getString("Estensione file non valida"));
      }
    },
  },
};
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/AdminShops.vue